import request from '../utils/request.js'
/**
 * 模拟练习2考题
 * @returns 
 */
 export function getMoeckQueList2(data){
    return request({
        url:'/getMoeckQueList2',
        method:'get',
        params:data
    })
}


/**
 * 获取资格类型
 * @returns 
 */
export function getExamTypeList(){
    return request({
        url:'/getMockExamTypeList',
        method:'get'
    })
}

/**
 * 获取工种类型
 * @returns 
 */
export function getWorkTypeList(){
    return request({
        url:'/getMockWorkTypeList',
        method:'get'
    })
}
/**
 * 获取题库
 * @param {*} data 
 * @returns 
 */
export function getQuestionList(data){
    return request({
        url:'/getMockQuestionList?workType='+data,
        method:'get'
    })
}
/**
 * 获取工种错题库
 * @param {} data 
 * @returns 
 */
export function getWrongQuestionList(data){
    return request({
        url:'/getWrongQuestionList?workType='+data,
        method:'get'
    })
}
//模拟考试排行
export function mockRank(data){
    return request({
        url:'/mockRank?workType='+data,
        method:'get'
    })
}
//错题上传
export function saveWrong(data){
    return request({
        url:'/addWrong',
        method:'post',
        data:data
    })
}
//模拟考试结果上传
export function saveMockExam(data){
    return request({
        url:'/addMockExam',
        method:'post',
        data:data
    })
}
//身份证信息上传
export function certification(data){
    return request({
        url:'/certification',
        method:'post',
        data:data
    })
}
//在线报名
export function registration(data){
    return request({
        url:'/registration',
        method:'post',
        data:data
    })
}





